import { render, staticRenderFns } from "./ProductFilterModel.vue?vue&type=template&id=8ab36e74&"
import script from "./ProductFilterModel.vue?vue&type=script&lang=js&"
export * from "./ProductFilterModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports